import { createContext, useContext, useState } from "react";
import { CMP, CMPVisibilityTypes } from "./CMP";

interface CmpContextInterface {
  hasAcceptedConsents: boolean;
  visibility: CMPVisibilityTypes;
  setHasAcceptedConsents: (value: boolean) => void;
  setVisibility: (value: CMPVisibilityTypes) => void;
}

const CmpContext = createContext<CmpContextInterface>({
  hasAcceptedConsents: false,
  visibility: "byCookieValue",
  setHasAcceptedConsents: (value: boolean) => {},
  setVisibility: (value: CMPVisibilityTypes) => {},
});

export interface ICmpProviderProps {
  defaultVisibility?: CMPVisibilityTypes;
  children: JSX.Element | JSX.Element[];
}

export const CmpProvider = ({
  children,
  defaultVisibility = "byCookieValue",
}: ICmpProviderProps) => {
  const [visibility, setVisibility] =
    useState<CMPVisibilityTypes>(defaultVisibility);
  const [hasAcceptedConsents, setHasAcceptedConsents] =
    useState<boolean>(false);

  return (
    <CmpContext.Provider
      value={{
        hasAcceptedConsents,
        setHasAcceptedConsents,
        visibility,
        setVisibility,
      }}
    >
      {children}
      <CMP />
    </CmpContext.Provider>
  );
};

export const useCmp = () => {
  const context = useContext(CmpContext);
  return context;
};
